import Tab, { TabPanel, Tabs } from 'components/src/tab';
import * as React from 'react';
import { FormTabsFieldsFragment } from 'types/generated';
import { getOr } from '@/utils/options';
import FormTabContent from './FormTabContent';

type Props = {
  tabs: (FormTabsFieldsFragment | null)[];
  selectedTab: number;
  onSetSelectedTab: (index: number) => void;
};

const FormTabs = ({ tabs, selectedTab, onSetSelectedTab }: Props) => {
  return (
    <div>
      <Tabs classes={'mt-4'}>
        {tabs.map((tab, index) => (
          <Tab
            key={index}
            index={index}
            buttonlayoutId="do-business-form-tab"
            label={getOr(tab?.title, '')}
            selected={selectedTab === index}
            onClick={onSetSelectedTab}
          />
        ))}
      </Tabs>
      {tabs.map((tab, index) => (
        <TabPanel value={selectedTab} index={index} key={index}>
          <FormTabContent tab={tab} />
        </TabPanel>
      ))}
    </div>
  );
};

export default FormTabs;
